import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Button } from '@material-ui/core';
//import styles from "./report.module.css";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	FormHelperText,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useAxiosPrivate from 'utils/hooks/useAxiosPrivate';
import moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

const theme = createTheme({
	palette: {
		primary: { light: '#56E4D7', main: '#56E4D7', dark: '#56E4D7' },
	},
});

export default function CustomReport(props) {
	const { onClose } = props;
	const axios = useAxiosPrivate();

	const users = useSelector((state) => state.user);
	const loggedInUserEmail = useSelector((state) => state.auth.email);
	const selectedUserIds = users.data.map((user) => user.user_id);

	const [alert, setAlert] = useState({
		showAlert: false,
		severity: 'error',
		message: '',
	});

	const [initialValues] = useState({
		date: new Date(),
		dateTo: new Date(),
		timeFrom: new Date(),
		timeTo: new Date(),
		type: 'csv', // Default type set to csv
	});
	const reportSchema = Yup.object().shape({
		date: Yup.date().required('Date from is required'),
		dateTo: Yup.date().required('Date to is required'),
		timeFrom: Yup.date().required('Time is required'),
		timeTo: Yup.date().required('Time to is required'),
		type: Yup.string().required('Type is required'),
	});
	const handleSubmit = async (event, actions) => {
		setAlert({
			showAlert: false,
			severity: '',
			message: '',
		});

		const data = {
			date: moment(event.date).format('YYYY-MM-DD'),
			date_to: moment(event.dateTo).format('YYYY-MM-DD'),
			time_from: moment(event.timeFrom).format('HH:mm') + ':00',
			time_to: moment(event.timeTo).format('HH:mm') + ':00',
			email: loggedInUserEmail,
			type: event.type,
			users: selectedUserIds,
		};

		try {
			const post = await axios.post('/report/download', data);

			const url = post?.data?.url;
			if (!url || post?.data?.status === 'ERROR') {
				setAlert({
					showAlert: true,
					severity: 'error',
					message: post?.data?.message || 'No data found',
				});
			} else {
				const isPdf = event.type === 'pdf';
				const mimeType = isPdf ? 'application/pdf' : 'text/csv';
				const dateFrom = moment(event.date).format('YYYY-MM-DD');
				const dateTo = moment(event.dateTo).format('YYYY-MM-DD');
				const timeFrom = moment(event.timeFrom).format('HH-mm');
				const timeTo = moment(event.timeTo).format('HH-mm');
				const fileName = `report_${dateFrom}_${timeFrom}_to_${dateTo}_${timeTo}.${event.type}`;

				const { data: fileData } = await axios.get(url, {
					responseType: 'blob',
				});

				const objectUrl = URL.createObjectURL(
					new Blob([fileData], { type: mimeType })
				);

				const link = document.createElement('a');
				link.href = objectUrl;
				link.download = fileName;
				link.click();

				URL.revokeObjectURL(objectUrl);
				actions.resetForm();

				if (onClose) {
					setTimeout(() => {
						onClose();
					}, 1500);
				} else {
					console.error('onClose function not provided to CustomReport component');
				}
			}
		} catch (error) {
			if (error?.response?.data?.message === 'user ids are required') {
				setAlert({
					showAlert: true,
					severity: 'error',
					message: 'Please choose a patient to download report.',
				});
			} else {
				setAlert({
					showAlert: true,
					severity: 'error',
					message: `${error.response.data.message}`,
				});
			}
		}
	};

	// const handleDateChange = (event, value) => {
	//   setInitialValues({ ...initialValues, date: event.target.value });
	// };
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<Formik
				initialValues={initialValues}
				onSubmit={handleSubmit}
				validationSchema={reportSchema}
			>
				{({
					dirty,
					isValid,
					errors,
					values,
					touched,
					field,
					setFieldValue,
					setFieldError,
				}) => {
					return (
						<Form>
							<Grid container justifyContent="center">
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ display: 'flex', justifyContent: 'center' }}
								>
									<Grid item xs={6} sm={6} md={6}>
										<Box sx={{ height: 70 }}>
											<MuiThemeProvider theme={theme}>
												<Field
													component={DatePicker}
													name="date"
													label="Date from"
													value={values.date}
													onChange={(value) =>
														setFieldValue('date', value, true)
													}
													slotProps={{
														textField: {
															variant: 'outlined',
															size: 'small',
															fullWidth: true,
														},
													}}
													error={Boolean(touched.date && errors.date)}
													helperText={touched.date && errors.date}
												></Field>
											</MuiThemeProvider>
										</Box>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ display: 'flex', justifyContent: 'center' }}
								>
									<Grid item xs={6} sm={6} md={6}>
										<Box sx={{ height: 70 }}>
											<MuiThemeProvider theme={theme}>
												<Field
													component={DatePicker}
													name="dateTo"
													label="Date to"
													onChange={(value) =>
														setFieldValue('dateTo', value, true)
													}
													value={values.dateTo}
													slotProps={{
														textField: {
															variant: 'outlined',
															size: 'small',
															fullWidth: true,
														},
													}}
													error={Boolean(touched.dateTo && errors.dateTp)}
													helperText={touched.dateTo && errors.dateTo}
												></Field>
											</MuiThemeProvider>
										</Box>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ display: 'flex', justifyContent: 'center' }}
								>
									<Grid item xs={6} sm={6} md={6}>
										<Box sx={{ height: 70 }}>
											<MuiThemeProvider theme={theme}>
												<Field
													component={TimePicker}
													name="timeFrom"
													label="Time from"
													onChange={(value) =>
														setFieldValue('timeFrom', value, true)
													}
													value={values.timeFrom}
													slotProps={{
														textField: {
															variant: 'outlined',
															size: 'small',
															fullWidth: true,
														},
													}}
													error={Boolean(touched.timeFrom && errors.timeFrom)}
													helperText={touched.timeFrom && errors.timeFrom}
												></Field>
											</MuiThemeProvider>
										</Box>
									</Grid>
								</Grid>

								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ display: 'flex', justifyContent: 'center' }}
								>
									<Grid item xs={6} sm={6} md={6}>
										<Box sx={{ height: 70 }}>
											<MuiThemeProvider theme={theme}>
												<Field
													component={TimePicker}
													name="timeTo"
													label="Time to"
													onChange={(value) =>
														setFieldValue('timeTo', value, true)
													}
													value={values.timeTo}
													slotProps={{
														textField: {
															variant: 'outlined',
															size: 'small',
															fullWidth: true,
														},
													}}
													error={Boolean(touched.timeTo && errors.timeTo)}
													helperText={touched.timeTo && errors.timeTo}
												></Field>
											</MuiThemeProvider>
										</Box>
									</Grid>
								</Grid>

								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ display: 'flex', justifyContent: 'center' }}
								>
									<Grid item xs={6} sm={6} md={6}>
										<Box sx={{ height: 70 }}>
											<MuiThemeProvider theme={theme}>
												<FormControl fullWidth size="small">
													<InputLabel id="type-label">Type</InputLabel>
													<Select
														labelId="type-label"
														id="type"
														name="type"
														value={values.type}
														onChange={(e) => {
															setFieldValue('type', e.target.value);
														}}
														label="Type"
														error={Boolean(
															values?.type === 'pdf' &&
																selectedUserIds?.length > 1
														)}
														helperText={errors.type && errors.type}
													>
														<MenuItem value="csv">csv</MenuItem>
														<MenuItem value="pdf">pdf</MenuItem>
													</Select>
													{Boolean(
														values?.type === 'pdf' &&
															selectedUserIds?.length > 1
													) && (
														<FormHelperText color="error">
															Only 1 user should be selected to download the PDF
															report
														</FormHelperText>
													)}
												</FormControl>
											</MuiThemeProvider>
										</Box>
									</Grid>
								</Grid>
								<Grid
									item
									container
									spacing={4}
									xs={8}
									sm={8}
									md={8}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										margin: '0rem 0rem 1rem 0rem',
									}}
								>
									<Grid
										item
										xs={6}
										sm={6}
										md={6}
										style={{ display: 'flex', justifyContent: 'center' }}
									>
										<Button
											fullWidth
											style={{
												fontSize: '0.9rem',
												lineHeight: '1.25rem',
												fontFamily: 'Poppins',
												fontWeight: 500,
												fontStyle: 'normal',
												height: 45,
												backgroundColor:
													!isValid ||
													Boolean(
														values?.type === 'pdf' &&
															selectedUserIds?.length > 1
													)
														? '#D9D9D9'
														: '#0F9BB0',
												color: 'white',
												textTransform: 'none',
											}}
											type="submit"
											disabled={
												!isValid ||
												Boolean(
													values?.type === 'pdf' && selectedUserIds?.length > 1
												)
											}
										>
											Export {values.type}
										</Button>
									</Grid>
								</Grid>

								{alert.showAlert && (
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										style={{ display: 'flex', justifyContent: 'center' }}
									>
										<Grid item xs={6} sm={6} md={6}>
											<Box sx={{ height: 70 }}>
												<Alert
													severity={alert.severity}
													onClose={() =>
														setAlert({
															...alert,
															showAlert: false,
														})
													}
												>
													{alert.message}
												</Alert>
											</Box>
										</Grid>
									</Grid>
								)}
							</Grid>
						</Form>
					);
				}}
			</Formik>
		</LocalizationProvider>
	);
}
